import { AppResolutionType } from '@/enums';
import { App, EditorialImage } from '@/services/graphQL/api/generated/types_web';
import { buildImageUrl } from '@/utils/mediaHelpers';

// Shared with the product intro, which warms this URL before navigating here.
// The two must agree or the navigation refetches.
export function frontdoorBackgroundUrl(
  app: App | undefined | null,
  currentResolution?: AppResolutionType
): string | undefined {
  const xlImageUrl = app?.introSplash?.breakpointImages?.find(
    (image: EditorialImage) => image.breakpoint === 'XL'
  )?.url;

  return xlImageUrl && buildImageUrl(xlImageUrl, { height: 1080 }, currentResolution);
}
